module.exports = __webpack_public_path__ + "static/img/gzh.9303301.png";


//////////////////
// WEBPACK FOOTER
// ./static/gzh.png
// module id = adJK
// module chunks = 1